var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2328.62 443.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bb2d5e;\n      }\n\n      .cls-2 {\n        fill: #dc5332;\n      }\n\n      .cls-3 {\n        fill: #132250;\n      }\n\n      .cls-4 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.64 254.61 255.07 443.04 0 443.04 66.64 254.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "426.79 331.92 140.55 45.68 156.7 0 307.48 0 426.79 331.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "466.73 443.04 325.78 443.04 85.12 202.38 122.07 97.9 466.46 442.3 466.73 443.04"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m736.13,396.52l-15.75-70h-82.6l-15.75,70h-55.3l86.1-350h52.5l86.1,350h-55.3Zm-87.5-119h60.9l-30.45-135.8-30.45,135.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1097.68,158.52c0,17.04-4.55,32.67-13.65,46.9-9.1,14.23-21.24,24.97-36.4,32.2l50.05,158.9h-54.95l-47.6-150.5h-24.85v150.5h-54.95V46.52h94.85c24.03,0,44.62,8.58,61.78,25.72,17.15,17.15,25.72,37.75,25.72,61.78v24.5Zm-65.62,23.62c7.12-9.92,10.67-21.88,10.67-35.88s-3.56-25.96-10.67-35.88c-7.12-9.92-15.58-14.88-25.38-14.88h-36.05v101.5h36.05c9.8,0,18.25-4.96,25.38-14.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1409.88,141.72h-54.95v-10.15c0-10.03-3.56-18.55-10.68-25.55-7.12-7-15.63-10.5-25.55-10.5s-18.38,3.5-25.38,10.5-10.5,15.52-10.5,25.55v179.9c0,10.04,3.5,18.55,10.5,25.55s15.46,10.5,25.38,10.5,18.43-3.5,25.55-10.5c7.12-7,10.68-15.51,10.68-25.55v-65.45h-36.05v-49h91v108.15c0,25.2-8.87,46.72-26.6,64.57-17.74,17.85-39.2,26.78-64.4,26.78s-46.72-8.92-64.57-26.78c-17.85-17.85-26.78-39.38-26.78-64.57v-167.3c0-25.2,8.92-46.72,26.78-64.57,17.85-17.85,39.38-26.78,64.57-26.78s46.67,8.92,64.4,26.78c17.73,17.85,26.6,39.38,26.6,64.57v3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1565.45,73.3c17.85-17.85,39.38-26.78,64.57-26.78s46.67,8.92,64.4,26.78c17.73,17.85,26.6,39.38,26.6,64.57v167.3c0,25.2-8.87,46.72-26.6,64.57-17.74,17.85-39.2,26.78-64.4,26.78s-46.72-8.92-64.57-26.78c-17.85-17.85-26.78-39.38-26.78-64.57v-167.3c0-25.2,8.92-46.72,26.78-64.57Zm100.62,238.17v-179.9c0-10.03-3.56-18.55-10.68-25.55-7.12-7-15.63-10.5-25.55-10.5s-18.38,3.5-25.38,10.5-10.5,15.52-10.5,25.55v179.9c0,10.04,3.5,18.55,10.5,25.55s15.46,10.5,25.38,10.5,18.43-3.5,25.55-10.5c7.12-7,10.68-15.51,10.68-25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1981.77,46.52h54.95v350h-54.95l-72.1-198.45v198.45h-55.3V46.52h55.3l72.1,198.45V46.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m2228.52,246.02v101.5h100.1v49h-155.05V46.52h155.05v49h-100.1v101.5h72.45v49h-72.45Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ba26045d84a1171091ac62761d4d9a20.svg";
export { ForwardRef as ReactComponent };